'use strict';

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toolbar = exports.ToolbarCheckbox = exports.ToolbarButton = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _dec2, _class3, _dec3, _class5;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _util = require('../util');

var _Icon = require('../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      background: theme.bgMeta,
      padding: [[10, 20]],
      display: 'flex',
      justifyContent: 'space-between',
      textAlign: 'left'
    },
    button: {
      padding: [[3, 4, 1, 4]],
      borderRadius: 5,
      border: [[1, 'solid', theme.colorMeta]],
      marginBottom: 2,
      background: theme.bgCard,
      cursor: 'pointer',
      '&[disabled]': {
        opacity: 0.5,
        cursor: 'not-allowed',
        color: [theme.colorMeta, '!important'],
        background: theme.bgMeta
      },
      '&:focus': {
        outline: 0,
        borderStyle: 'dashed'
      },
      '&:not(:last-child)': {
        marginRight: 15
      }
    },
    buttonDanger: {
      '&:hover': {
        color: theme.reject
      }
    },
    buttonActive: {
      background: theme.bgHighlight
    },
    checkbox: {
      display: 'inline-block',
      position: 'relative',
      top: 0,
      marginRight: 14,
      fontSize: 14,
      cursor: 'pointer',
      fontWeight: 'bold',
      whiteSpace: 'nowrap'
    },
    checkboxDisabled: {
      opacity: 0.65
    },
    checkboxLabel: {
      marginLeft: 8,
      userSelect: 'none'
    }
  };
};

var ToolbarButton = exports.ToolbarButton = (_dec = (0, _util.withStyles)(styles), _dec(_class = function (_React$Component) {
  _inherits(ToolbarButton, _React$Component);

  function ToolbarButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToolbarButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToolbarButton.__proto__ || Object.getPrototypeOf(ToolbarButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);
      event.target.blur();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ToolbarButton, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          id = _props.id,
          title = _props.title,
          keyName = _props.keyName,
          active = _props.active,
          icon = _props.icon,
          classes = _props.classes,
          theme = _props.theme,
          _props$size = _props.size,
          size = _props$size === undefined ? 22 : _props$size,
          onClick = _props.onClick,
          props = _objectWithoutProperties(_props, ['id', 'title', 'keyName', 'active', 'icon', 'classes', 'theme', 'size', 'onClick']);

      var btnClassNames = (0, _classnames2["default"])(classes.button, (_classNames = {}, _defineProperty(_classNames, classes.buttonActive, active), _defineProperty(_classNames, classes.buttonDanger, id === 'delete' || id === 'reset'), _classNames));
      var labelText = title || id;
      var label = keyName ? labelText + ' (' + keyName + ')' : labelText;
      return _react2["default"].createElement('button', _extends({
        className: btnClassNames,
        onClick: this.handleClick,
        title: label,
        'aria-label': label
      }, props), _react2["default"].createElement(_Icon2["default"], {
        name: id,
        size: size
      }));
    }
  }]);

  return ToolbarButton;
}(_react2["default"].Component)) || _class);
var ToolbarCheckbox = exports.ToolbarCheckbox = (_dec2 = (0, _util.withStyles)(styles), _dec2(_class3 = function (_React$Component2) {
  _inherits(ToolbarCheckbox, _React$Component2);

  function ToolbarCheckbox() {
    var _ref2;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, ToolbarCheckbox);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = ToolbarCheckbox.__proto__ || Object.getPrototypeOf(ToolbarCheckbox)).call.apply(_ref2, [this].concat(args))), _this2), _this2.id = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(ToolbarCheckbox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.id = (0, _v2["default"])();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          label = _props2.label,
          keyName = _props2.keyName,
          checked = _props2.checked,
          onChange = _props2.onChange,
          disabled = _props2.disabled,
          classes = _props2.classes,
          theme = _props2.theme,
          props = _objectWithoutProperties(_props2, ['id', 'label', 'keyName', 'checked', 'onChange', 'disabled', 'classes', 'theme']);

      var labelId = id || this.id;
      var checkboxClassNames = (0, _classnames2["default"])(classes.checkbox, _defineProperty({}, classes.checkboxDisabled, disabled));
      var title = keyName ? '(' + keyName + ')' : null;
      return _react2["default"].createElement('label', {
        htmlFor: labelId,
        className: checkboxClassNames,
        title: title
      }, _react2["default"].createElement('input', _extends({
        id: labelId,
        type: 'checkbox',
        checked: checked,
        onChange: onChange
      }, props)), _react2["default"].createElement('span', {
        className: classes.checkboxLabel
      }, label));
    }
  }]);

  return ToolbarCheckbox;
}(_react2["default"].Component)) || _class3);
var Toolbar = exports.Toolbar = (_dec3 = (0, _util.withStyles)(styles), _dec3(_class5 = function (_React$Component3) {
  _inherits(Toolbar, _React$Component3);

  function Toolbar() {
    _classCallCheck(this, Toolbar);

    return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
  }

  _createClass(Toolbar, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          classes = _props3.classes;
      return _react2["default"].createElement('div', {
        className: classes.root
      }, children);
    }
  }]);

  return Toolbar;
}(_react2["default"].Component)) || _class5);